import { createAsyncThunk } from '@reduxjs/toolkit';
import { TApplicationState } from '../../types/redux';
import { fetchFlatData } from './fetchFlatData';
import { IApplicationContext } from '../../types/applicationContext';
import { selectFilters, selectFlatFormValues } from '../../selectors/filters';
import { validateFilters } from '@cian/valuation-main-filters-widget';
import { trackMyHomeWithFlatNumberAnalytics } from '../../containers/AddNewCard/analytics/trackMyHomeWithFlatNumberAnalytics';
import { selectSource } from 'shared/selectors/page';

export const submitFlatData = createAsyncThunk('form/submitFlatData', async (_, _thunkApi) => {
  const { extra, rejectWithValue, getState, dispatch } = _thunkApi;
  const state = getState() as TApplicationState;

  const isFormValid = await dispatch(validateFilters());

  if (!isFormValid) {
    return;
  }

  const filters = selectFilters(state);
  const { myHome } = filters;
  const source = selectSource(state);

  const { houseId, area, roomsCount, flatNumber } = selectFlatFormValues(state);

  if (!houseId || !area || !roomsCount) {
    return;
  }

  const parameters = {
    houseId,
    area,
    roomsCount,
    flatNumber,
    isNeedPushSubscribe: false,
    source,
  };

  try {
    const res = await fetchFlatData(parameters, extra as IApplicationContext);

    if (myHome?.withRoomNumber) {
      trackMyHomeWithFlatNumberAnalytics(filters, true);
    }

    return res;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});
